export var local = false

export function getPlatformName() {
    return 'Discourseify';
}

export function defaultErrorMsg() {
    return 'An error occurred, please try again later';
}

export function getBackendURL() {
    if(local){
        return 'http://localhost:2323'
    }
    return 'https://api.discourseify.com'
}

export function calculateTimeElapsed(x) {
    const xDate = new Date(x);
    const now = new Date();
    const diffTimeSeconds = Math.abs(now - xDate) / 1000;
    const diffDays = Math.floor(diffTimeSeconds / (60 * 60 * 24));
    const diffHours = Math.floor(diffTimeSeconds / (60 * 60));
    const diffMinutes = Math.floor(diffTimeSeconds / 60);
    const diffSeconds = Math.floor(diffTimeSeconds);
    if (diffDays > 0) {
        return `${diffDays}d`;
    } else if (diffHours > 0) {
        return `${diffHours}h`;
    } else if (diffMinutes > 0) {
        return `${diffMinutes}m`;
    }
    return `${diffSeconds}s`;
}

export function validateUsername(username) {
    let errorMsg = null;
    if (username.length < 4 || username.length > 16) {
        errorMsg = 'Username must be between 4 and 16 characters long';
    }
    if (!/^[a-z0-9_]+$/.test(username)) {
        errorMsg = 'Username must contain only lowercase letters, digits, and underscores';
    }
    return errorMsg;
}